G.BoardCandy = G.BoardCandy || {};

G.BoardCandy.CakeType = function() {
  G.BoardCandy.CandyType.call(this);
};

G.BoardCandy.CakeType.prototype = Object.create(G.BoardCandy.CandyType.prototype);

G.BoardCandy.CakeType.prototype.init = function(candy, config, hp) {
  this.candy = candy;
  this.maxHp = 4;
  this.hp = parseInt(G.Utils.defined(hp, this.maxHp));
  this.spriteName = config.texture;
  this.matchable = G.Utils.defined(config.matchable, true);
  this.canBeChangedIntoSpecialType = G.Utils.defined(config.canHaveSpecialType, true);
  this.tags = G.Utils.defined(config.tags, []);
  this.editorSymbol = G.Utils.defined(config.editorSymbol, "");

  this.FALLINGBLOCKED = true;

  this.updateSprite();
};

G.BoardCandy.CakeType.prototype.onMatch = function() {
  return false;
};

G.BoardCandy.CakeType.prototype.onHit = function() {
  return false;
};

G.BoardCandy.CakeType.prototype.onMove = function(otherCandy) {
  this.decreateHp();
  return true;
};

G.BoardCandy.CakeType.prototype.onBooster = function() {
  this.decreateHp();
};

G.BoardCandy.CakeType.prototype.decreateHp = function() {
  this.hp--;

  if (this.hp > 0) {
    this.updateSprite();
  } else {
    this.signals.removeCandy.dispatch();
  }
};

G.BoardCandy.CakeType.prototype.updateSprite = function() {
  this.signals.changeCandyTexture.dispatch(this.spriteName.replace("HP", this.hp+1));
};

G.BoardCandy.CakeType.prototype.export = function() {
  return this.editorSymbol + "|" + this.hp;
};

G.BoardCandy.CakeType.prototype.changeForEditor = function() {
  if (this.hp === 1) {
    this.hp = this.maxHp;
  } else {
    this.hp--;
  }
  this.updateSprite();
};